module.exports = __webpack_public_path__ + "img/Weapon_126.3fbf0afe.png";